import { RodRoom } from '@bechtel/types';
import React, { createContext, useState } from 'react';
import { CacheKeys } from '@bechtel/client-common';

type RodRoomContextType = {
  selectedRodRoom: RodRoom | null;
  setSelectedRodRoom: React.Dispatch<React.SetStateAction<RodRoom | null>>;
};

type RodRoomContextProviderProps = {
  children: React.ReactNode;
};

export const RodRoomDataContext = createContext<RodRoomContextType>({} as RodRoomContextType);

export const RodRoomContextProvider = ({ children }: RodRoomContextProviderProps) => {
  const rodRoom: RodRoom = JSON.parse(window.sessionStorage.getItem(CacheKeys.SelectedRodRoom));
  const [selectedRodRoom, setSelectedRodRoom] = useState<RodRoom | null>(rodRoom?.id ? rodRoom : null);
  return (
    <RodRoomDataContext.Provider value={{ selectedRodRoom, setSelectedRodRoom }}>
      {children}
    </RodRoomDataContext.Provider>
  );
};
